var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pwa-banner btn",attrs:{"type":"button"}},[_c('span',{staticStyle:{"max-width":"230px"}},[_vm._v(_vm._s(_vm.$t('pwa.banner.text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }